// Which selected policies filled no ACORD 25 coverage row.
//
// get-coverages assigns a policy to a certificate section by its line of business. A policy
// on a line NowCerts does not recognise for the form (a Life-Health "Umbrella Coverage", an
// Agriculture line, a policy with no line at all) comes back as generic rows only: nothing our
// field maps read, so no policy number, dates or limits fill. Without a warning the agent only
// finds out from the preview that the certificate is blank.
//
// The form reports the policy numbers that landed in any row (CGL, Auto, Umbrella, WC, Other);
// a selected policy whose number is not among them is unmapped. Matching on number means a
// policy that lands in the wrong row (a GL policy NowCerts files under Auto) still counts as
// mapped — that is a data problem on the policy, not a blank certificate.

export type PolicyOptionLike = {
  value: string;
  number: string;
  linesOfBusiness: string[];
  policyType: string | null;
};

export function normalizePolicyNumber(n: string | null | undefined): string {
  return (n ?? '').trim().toUpperCase();
}

export function findUnmappedPolicies<T extends PolicyOptionLike>(
  selectedIds: string[],
  options: T[],
  mappedPolicyNumbers: string[]
): T[] {
  const mapped = new Set(mappedPolicyNumbers.map(normalizePolicyNumber).filter(Boolean));
  return selectedIds
    .map(id => options.find(o => o.value === id))
    .filter((o): o is T => !!o)
    .filter(o => !mapped.has(normalizePolicyNumber(o.number)));
}

/** "General Liability, Commercial Auto", the custom PolicyType if set, or a fallback. */
export function describePolicyLob(o: PolicyOptionLike): string {
  if (o.policyType) return o.policyType;
  if (o.linesOfBusiness.length) return o.linesOfBusiness.join(', ');
  return 'no line of business';
}
